/**
 * static/js/utils/submit-once.js
 *
 * Drops a repeat submit of any POST form for HOLD_MS after the first one
 * (auto-submit plus Enter, a double tap). Listens on window so a submit a page
 * already cancelled (AJAX, Stripe create-then-submit) is left alone, and
 * re-arms instead of locking because a download or target=_blank POST never
 * leaves the page.
 */
(function (window, document) {
  'use strict';

  var SENT = 'data-submit-once-sent';
  var HOLD_MS = 5000;

  function buttons(form) {
    return form.querySelectorAll('button[type="submit"], button:not([type]), input[type="submit"]');
  }

  function setDisabled(form, disabled) {
    var list = buttons(form);
    for (var i = 0; i < list.length; i++) list[i].disabled = disabled;
  }

  function release(form) {
    form.removeAttribute(SENT);
    setDisabled(form, false);
  }

  function onSubmit(e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement) || e.defaultPrevented) return;
    if ((form.getAttribute('method') || 'get').toLowerCase() !== 'post') return;
    if (form.hasAttribute(SENT)) {
      e.preventDefault();
      return;
    }
    form.setAttribute(SENT, '');
    // Disabled after the event so the submitter still lands in the form data.
    window.setTimeout(function () { setDisabled(form, true); }, 0);
    window.setTimeout(function () { release(form); }, HOLD_MS);
  }

  window.addEventListener('submit', onSubmit);
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var forms = document.querySelectorAll('form[' + SENT + ']');
    for (var i = 0; i < forms.length; i++) release(forms[i]);
  });
})(window, document);
